<app-bread-crumb></app-bread-crumb>
<app-lecture-info [data]="this.SeminarForm"></app-lecture-info>
